export default __webpack_public_path__ + "static/media/number0.64f70898.svg";